import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss']
})
export class Page404Component {
  constructor(
    private location: Location,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  goBack(): void {
    const from = this.route.snapshot.queryParamMap.get('from');
    if (from && from !== '/' && !from.startsWith('/404')) {
      this.router.navigateByUrl(from);
    } else {
      this.location.back();
    }
  }
}
